var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-radio-group',{attrs:{"mandatory":false},on:{"change":_vm.onChange},model:{value:(_vm.pd),callback:function ($$v) {_vm.pd=$$v},expression:"pd"}},_vm._l((_vm.items),function(d){return _c('v-radio',{key:d.Value,attrs:{"color":"primary","label":d.Label,"value":d.Value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }